import { render, staticRenderFns } from "./search_custome.vue?vue&type=template&id=96544c9e&"
import script from "./search_custome.vue?vue&type=script&lang=js&"
export * from "./search_custome.vue?vue&type=script&lang=js&"
import style0 from "./search_custome.vue?vue&type=style&index=0&id=96544c9e&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports